import React, { Component } from "react";
import { Redirect } from "react-router-dom";
import Slider from "react-animated-slider";
import "react-animated-slider/build/horizontal.css";
import "./slider-animations.css";
import "./style.css";

const styles = {
  fontFamily: "sans-serif",
  textAlign: "center"
};

const content = [
  {
    title: "Crypto Trade ",
    description: "",
    button: "Start Now",
    image: require('../../img/img2.jpg')
  },
  {
    title: "Crypto Trade",
    description: "",
    button: "Start Now",
    image:require('../../img/img1.jpeg')
  },
  {
    title: "Crypto Trade",
    description: "",
    button: "Start Now",
    image: require('../../img/img3.jpeg')
  }
];
export default class BodyContent extends Component {
  state = {
    redirect: false
  };

  start() {
    this.setState({ redirect: true });
  }

  render() {
    if (this.state.redirect) {
      return <Redirect to="/dashboard" />;
    }
    return (
      <div style={styles}>
        <Slider className="slider-wrapper" autoplay={2000}>
          {content.map((item, index) => (
            <div
              key={index}
              className="slider-content"
              style={{
                background: `url('${item.image}') no-repeat center center`
              }}
            >
              <div className="inner">
                <h1>{item.title}</h1>
                <p>{item.description}</p>
                <button>
                  <a href="/login">{item.button}</a>
                </button>
              </div>
            </div>
          ))}
        </Slider>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/Home/BodyContent.js